import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography, CircularProgress, FormControl, MenuItem, Select, InputLabel, Chip } from "@material-ui/core";
import * as Yup from "yup";
import ImageUpload from './imageUploadForm';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { types } from './utils';

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%",
        marginBottom: '5px',
    },
    formControlAutocomplete: {
        width: "100%",
        marginBottom: '5px',
        paddingTop: theme.spacing(3)
    },
});

const SystemCertificateForm = props => {
    const { classes, formSettings, initialValues, productTypes, edit, handleUpload, handleSubmit, imageValue, translations } = props;

    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, setFieldValue, handleChange, handleBlur, handleSubmit } = formikProps;

                    let allProductTypes = (productTypes ?? []).map(el => el.value);
                    let initialValuesProductTypes = (values?.ProductTypes ?? []).map(el => el.value);
                    let difference = (allProductTypes ?? []).filter(productType => !initialValuesProductTypes.includes(productType));
                    let optionsProductTypes = (productTypes ?? []).filter(el => difference.includes(el.value));

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations['select_type'] || "Please select type"}</InputLabel>
                                <Select
                                    name="Type"
                                    label={translations["type"] || "Type"}
                                    margin={"dense"}
                                    value={(values?.Type && values?.Type) ?? ''}
                                    onChange={handleChange}
                                >
                                    {(types ? types : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {translations[option.value] || option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl className={classes.formControlAutocomplete}>
                                <InputLabel shrink>{translations['select_product_type'] || "Please select product type"}</InputLabel>
                                <Autocomplete
                                    name={'ProductTypes'}
                                    multiple
                                    id="ProductTypes"
                                    options={optionsProductTypes || []}
                                    getOptionLabel={(option) => translations[option?.label] || option?.name}
                                    filterSelectedOptions
                                    value={values?.ProductTypes}
                                    onChange={(_, el) => setFieldValue('ProductTypes', el)}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" fullWidth={true} />
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip label={translations[option?.label] || option?.name} {...getTagProps({ index })} />
                                        ))
                                    }
                                />
                            </FormControl>
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <ImageUpload handleUpload={handleUpload} imageValue={imageValue} edit={edit} />
                            </FormControl>
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !(isValid && dirty) || !imageValue}
                                    >
                                        {(isSubmitting) ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(SystemCertificateForm);
